// extracted by mini-css-extract-plugin
module.exports = {"textLogo1":"navigation_textLogo1__3yfxL","learnMore":"navigation_learnMore__30XKG"};